export const tableSearcherTranslations = {
  search: 'table-search.search',
  clear: 'table-search.clear',
  filters: 'table-search.filters',
  searchPlaceholder: 'table-search.search-placeholder',
  selectPrefix: 'table-search.select-prefix',
}
